import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "題目",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "選項",
    isNumber: true,
    isSum: true,
  },
];

export const VillageToNutrition = {
  label: "鄉鎮 vs 營養管理",
  key: "VillageToNutrition",
  path: "BMI/VillageToNutrition",
  api: "TCS_V_BMIHENutritionV",
  render: (options) => <Diagram.BMI.VillageToNutrition {...options} />,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
